import { createAction } from 'redux-act'
import { UserProfile } from 'types/userTypes'
import { UsersFilterState } from '../components/types'

export const CHANGE_FILTER_STATE = createAction(
  '{USERS} Change Filter State',
  (userFilters: UsersFilterState) => ({
    userFilters,
  })
)

export const LOAD_USERS = createAction('{USERS} Load Users')

export const LOAD_USERS_SUCCESS = createAction(
  '{USERS} Load Users Success',
  (users: UserProfile[], count: number) => ({ count, users })
)

export const LOAD_USERS_FAILED = createAction(
  '{USERS} Load Users Failed',
  (message: string) => ({ message })
)
